import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/detail/message.svg'
import _imports_1 from '@/assets/img/detail/video2.svg'
import _imports_2 from '@/assets/img/detail/twitter_share.svg'
import _imports_3 from '@/assets/img/detail/line_share.svg'
import _imports_4 from '@/assets/img/detail/back.svg'


const _withScopeId = n => (_pushScopeId("data-v-1488b41e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "detail" }
const _hoisted_2 = { class: "name" }
const _hoisted_3 = { class: "profile" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = { class: "photos" }
const _hoisted_6 = { class: "image-box" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "thumbnail" }
const _hoisted_9 = ["src", "onClick"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "profile"
  })
], -1))
const _hoisted_11 = { class: "message" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "自分で思う長所", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "趣味", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "あこがれの俳優", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "一言", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    id: "video"
  })
], -1))
const _hoisted_17 = { class: "video" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "youtube" }
const _hoisted_20 = ["src"]
const _hoisted_21 = { class: "share" }
const _hoisted_22 = ["href"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = ["href"]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.actress.name), 1),
    _createElementVNode("div", _hoisted_3, [
      _createTextVNode(_toDisplayString(_ctx.actress.kana), 1),
      _hoisted_4,
      _createTextVNode(_toDisplayString(_ctx.actress.age) + " / " + _toDisplayString(_ctx.actress.place), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_Transition, {
          name: "image",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock("img", {
              src: `/actress/profile/${_ctx.actress.entry_no}_${( '00' + _ctx.select ).slice( -2 )}.jpg`,
              class: "main",
              key: _ctx.select,
              alt: ""
            }, null, 8, _hoisted_7))
          ]),
          _: 1
        })
      ]),
      _createElementVNode("ul", _hoisted_8, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(8, (index) => {
          return _createElementVNode("li", { key: index }, [
            _createElementVNode("img", {
              src: `/actress/profile/${_ctx.actress.entry_no}_${( '00' + index ).slice( -2 )}.jpg`,
              class: _normalizeClass([_ctx.select === index ?'select':'']),
              onClick: ($event: any) => {_ctx.select=index;},
              alt: ""
            }, null, 10, _hoisted_9)
          ])
        }), 64))
      ])
    ]),
    _hoisted_10,
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("dl", null, [
        _hoisted_12,
        _createElementVNode("dd", null, [
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actress.profile1.split(/\n/), (val, index) => {
              return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(val), 1))
            }), 128))
          ])
        ]),
        _hoisted_13,
        _createElementVNode("dd", null, [
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actress.profile2.split(/\n/), (val, index) => {
              return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(val), 1))
            }), 128))
          ])
        ]),
        _hoisted_14,
        _createElementVNode("dd", null, [
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actress.profile3.split(/\n/), (val, index) => {
              return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(val), 1))
            }), 128))
          ])
        ]),
        _hoisted_15,
        _createElementVNode("dd", null, _toDisplayString(_ctx.actress.profile4), 1)
      ])
    ]),
    _hoisted_16,
    _createElementVNode("div", _hoisted_17, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.videoList, (item, index) => {
        return (_openBlock(), _createElementBlock("div", { key: index }, [
          (item.type==='default' && item.src !== '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("iframe", {
                    width: "560",
                    height: "315",
                    src: `https://www.youtube.com/embed/${item.src}?rel=0`,
                    title: "YouTube video player",
                    frameborder: "0",
                    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                    allowfullscreen: ""
                  }, null, 8, _hoisted_20)
                ]),
                _createElementVNode("span", null, _toDisplayString(item.caption), 1)
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("a", {
        target: "_blank",
        href: 'https://twitter.com/intent/tweet?text=%F0%9F%92%8E%E3%80%8E%E7%A7%81%E3%81%8C%E5%A5%B3%E5%84%AA%E3%81%AB%E3%81%AA%E3%82%8B%E6%97%A5_%E3%80%8F%F0%9F%92%8E%0A%0A%EF%BC%8F%0A%E3%81%BF%E3%82%93%E3%81%AA%E3%81%AE%E6%8A%95%E7%A5%A8%E3%81%A7TBS%E3%83%89%E3%83%A9%E3%83%9E%E3%81%AE%E4%B8%BB%E6%BC%94%E3%81%8C%E6%B1%BA%E5%AE%9A%E2%9C%A8%0A%E3%82%B0%E3%83%A9%E3%83%B3%E3%83%97%E3%83%AA%E3%82%92%E9%81%B8%E3%81%B6%E8%A6%96%E8%81%B4%E8%80%85%E6%8A%95%E7%A5%A8%E3%81%8C%E9%96%8B%E5%82%AC%E4%B8%AD%E2%80%BC%EF%B8%8F%0A%EF%BC%BC%0A%0A%E5%80%99%E8%A3%9C%E8%80%85%E4%B8%80%E8%A6%A7%E3%81%A8%E6%8A%95%E7%A5%A8%E3%81%AF%E3%81%93%E3%81%A1%E3%82%89%E3%81%8B%E3%82%89%F0%9F%A4%B3%0A%F0%9F%91%89https%3A%2F%2Flin.ee%2FHfAOZCD%0A%0A%E7%95%AA%E7%B5%84%E6%83%85%E5%A0%B1%E3%81%AF%40watajo_tbs%20%E3%82%92%E3%83%81%E3%82%A7%E3%83%83%E3%82%AF%E2%9D%97%0A%0A%23%E7%A7%81%E3%81%8C%E5%A5%B3%E5%84%AA%E3%81%AB%E3%81%AA%E3%82%8B%E6%97%A5%0A%23%E8%A6%96%E8%81%B4%E8%80%85%E3%82%AD%E3%83%A3%E3%82%B9%E3%83%86%E3%82%A3%E3%83%B3%E3%82%B0%0A%23TBS'
      }, _hoisted_24, 8, _hoisted_22),
      _createElementVNode("a", { href: 'https://line.me/R/share?text=%F0%9F%92%8E%E3%80%8E%E7%A7%81%E3%81%8C%E5%A5%B3%E5%84%AA%E3%81%AB%E3%81%AA%E3%82%8B%E6%97%A5_%E3%80%8F%F0%9F%92%8E%0A%0A%EF%BC%8F%0A%E3%81%BF%E3%82%93%E3%81%AA%E3%81%AE%E6%8A%95%E7%A5%A8%E3%81%A7TBS%E3%83%89%E3%83%A9%E3%83%9E%E3%81%AE%E4%B8%BB%E6%BC%94%E3%81%8C%E6%B1%BA%E5%AE%9A%E2%9C%A8%0A%E3%82%B0%E3%83%A9%E3%83%B3%E3%83%97%E3%83%AA%E3%82%92%E9%81%B8%E3%81%B6%E8%A6%96%E8%81%B4%E8%80%85%E6%8A%95%E7%A5%A8%E3%81%8C%E9%96%8B%E5%82%AC%E4%B8%AD%E2%80%BC%EF%B8%8F%0A%EF%BC%BC%0A%0A%E5%80%99%E8%A3%9C%E8%80%85%E4%B8%80%E8%A6%A7%E3%81%A8%E6%8A%95%E7%A5%A8%E3%81%AF%E3%81%93%E3%81%A1%E3%82%89%E3%81%8B%E3%82%89%F0%9F%A4%B3%0A%F0%9F%91%89https%3A%2F%2Flin.ee%2FHfAOZCD' }, _hoisted_27, 8, _hoisted_25)
    ]),
    _createVNode(_component_router_link, {
      to: { path: _ctx.backPage},
      class: "backButton"
    }, {
      default: _withCtx(() => [
        _hoisted_28
      ]),
      _: 1
    }, 8, ["to"])
  ]))
}